// src/components/common/ProductCard.jsx
import React from 'react';
import Star from './Star';
import { Heart } from 'lucide-react';
import './productCard.css';

const ProductCard = ({ image, title, description, price, discount, rating, icon, onClick }) => {
  // Define a class for the background image based on the image prop
  const imageClass = () => `bg-${image}`; // Assuming image prop is a valid class name

  return (
    <div
      className="bg-white cursor-pointer rounded-xl shadow-sm p-3 min-w-40 border border-gray-100"
      onClick={onClick}
    >
      <div
        className={`${imageClass()} h-28 rounded-lg mb-2 relative`}
      >
        {discount && (
          <div className="absolute top-2 left-2 bg-red-500 text-white text-xs font-semibold px-2 py-1 rounded-md">
            {discount}
          </div>
        )}
        <button className="absolute top-2 right-2 bg-white p-1 rounded-md">
          <Heart size={16} className="text-gray-400" />
        </button>
      </div>
      <div className="flex items-center mb-1">
        {icon}
        <h4 className="font-semibold text-gray-800 ml-1">{title}</h4>
      </div>
      <p className="text-xs text-gray-500 mb-2">{description}</p>
      <div className="flex justify-between items-center">
        <p className="font-bold text-gray-800">{price}</p>
        <div className="flex items-center bg-green-50 px-2 py-1 rounded-md">
          <Star />
          <span className="text-xs font-medium text-gray-700 ml-1">{rating}</span>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;